import round6Decimals from "../../../../Components/round6Decimals";

//Conversión precio sin impuestos <-> con impuestos para los insumos extra que se capturan al
//generar ventas programadas (p. ej. la luz, que el cliente trae con IVA incluido del recibo).
//Es la misma aritmética de AgregarVenta onChangePrecioConImpuestos: las tasas sobre el valor se
//suman al factor, las que van sobre valor + impuestos previos lo multiplican, y las cuotas por
//unidad se suman/restan aparte (divididas entre el tipo de cambio).

const factorYCuotas = (impuestos, tipoDeCambio) => {
    let factor = 1;
    let sumaCuotasFijas = 0;
    (impuestos || []).forEach((valueImpuesto) => {
        const porcentaje = valueImpuesto.monto / 100;
        if (valueImpuesto.tasaCuota === 1) {
            factor += porcentaje;
        } else if (valueImpuesto.tasaCuota === 2) {
            factor *= (1 + porcentaje);
        } else if (valueImpuesto.tasaCuota === 3) {
            sumaCuotasFijas += valueImpuesto.monto / (tipoDeCambio || 1);
        }
    });
    return { factor, sumaCuotasFijas };
};

export const precioConImpuestos = (precioUnitario, impuestos, tipoDeCambio) => {
    if (precioUnitario === undefined || precioUnitario === null || precioUnitario === "") return undefined;
    const { factor, sumaCuotasFijas } = factorYCuotas(impuestos, tipoDeCambio);
    return round6Decimals(Number(precioUnitario) * factor + sumaCuotasFijas);
};

export const precioSinImpuestos = (precioConImp, impuestos, tipoDeCambio) => {
    if (precioConImp === undefined || precioConImp === null || precioConImp === "") return undefined;
    const { factor, sumaCuotasFijas } = factorYCuotas(impuestos, tipoDeCambio);
    return round6Decimals((Number(precioConImp) - sumaCuotasFijas) / factor);
};

//Precio de la lista de la venta programada; 0 si el insumo no tiene precio en esa lista
export const precioDeLista = (insumo, precioId) => {
    const precio = (insumo?.precios || []).find(
        (valuePrecio) => valuePrecio.precioId?.toString() === precioId?.toString()
    );
    return precio ? Number(precio.precio) || 0 : 0;
};
